import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a484402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marketing-body" }
const _hoisted_2 = { class: "marketing-content" }
const _hoisted_3 = { class: "content-body" }
const _hoisted_4 = { class: "content-left" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-title" }, "营销入口", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-subtitle" }, "企业宣传创新解决方案，打造企业宣传名片", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-details" }, "系统全面的搭建企业宣传和产品推广创新方案，动态化展示公司主营业务＋产品，行业信息以及商品信息帮助用户讲好公司故事、产品故事、塑造企业形象，打造宣传名片。", -1))


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "marketingView",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const linkEvent = () => {
  window.open("https://show.333f.com/ieds-h5-sct/index", "_blank");
};

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_carousel, { "indicator-position": "outside" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                'https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/1685592609123.png',
                'https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/1685592609126.png',
                'https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/1685592609124.png',
                'https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/1685592609125.png',
              ], (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "banner-img",
                      src: item,
                      alt: ""
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", { class: "content-right" }, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", {
            onClick: linkEvent,
            class: "marketing-btn"
          }, "立即体验")
        ])
      ])
    ])
  ]))
}
}

})